import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=6e8e5e76"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports